var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var LogoutButtonStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  textalign: '-webkit-center';\n"], ["\n  cursor: pointer;\n  textalign: '-webkit-center';\n"])));
export var LogoutButtonV2Styled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n"], ["\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n"])));
var templateObject_1, templateObject_2;
